import Typography from '@mui/material/Typography'
import React from 'react'

import HHConfirmDialog from 'components/common/HHConfirmDialog'
import T from 'T'
import { Z_INDEX } from 'theme/zIndex'

type PrintOnlyConfirmDialogProps = {
  isOpen: boolean
  onGoBack: () => void
  onSetToPrintOnly: () => void
}

const PrintOnlyConfirmDialog = ({ isOpen, onGoBack, onSetToPrintOnly }: PrintOnlyConfirmDialogProps) => (
  <HHConfirmDialog
    CancelButtonProps={{ color: 'primary' }}
    cancelButtonTitle={T.GO_BACK_AND_ADD_EMAIL}
    ConfirmButtonProps={{ color: 'primary' }}
    confirmButtonTitle={T.TURN_ON_RECEIVES_PRINTED_COPY}
    confirmDescription={
      <>
        {T.NO_BILLING_EMAIL_PRINTED_COPY_LEAD}
        <strong>{T.RECEIVES_PRINTED_COPY}</strong>
        {T.NO_BILLING_EMAIL_PRINTED_COPY_TAIL}
        <Typography color="text.secondary" component="span" display="block" mt={2} variant="body2">
          {T.PRINTED_COPY_CHANGEABLE_ON_BILLING_TAB}
        </Typography>
      </>
    }
    confirmTitle={T.NO_BILLING_EMAIL_TITLE}
    DialogProps={{ sx: { zIndex: Z_INDEX.ELEVATED_DIALOG } }}
    isOpen={isOpen}
    onClose={onGoBack}
    onConfirm={onSetToPrintOnly}
  />
)

export default PrintOnlyConfirmDialog
